import MuiMenu, {MenuProps as MuiMenuProps} from '@mui/material/Menu'

import 'shared/ui/styles/popup.scss'

export const Menu: React.FC<MuiMenuProps> = ({
  children,
  classes,
  ...rest
}) => {
  return (
    <MuiMenu
      classes={{
        ...classes,
        paper: `override-popup-paper ${classes?.paper}`,
        list: `override-popup-list ${classes?.list}`
      }}
      {...rest}
    >
      {children}
    </MuiMenu>
  )
}
